import { SignDesignDocumentV2, SignQrLayer } from './types';

export interface ClientQrValidation { valid: boolean; codes: string[] }
export interface FabricQrCandidate {
  visible?: boolean;
  intrlockData?: { type?: string; target?: string };
}
const contrastOk = (a = '#000000', b = '#ffffff') => a.toLowerCase() !== b.toLowerCase();

export function validateFabricQrForAdvance(objects: FabricQrCandidate[], canonicalTarget: string): ClientQrValidation {
  const qrs = objects.filter(object => object.visible !== false && object.intrlockData?.type === 'qr');
  if (!qrs.length) return { valid: false, codes: ['QR_MISSING'] };
  if (!qrs.some(qr => qr.intrlockData?.target === canonicalTarget)) {
    return { valid: false, codes: ['QR_TARGET_INVALID'] };
  }
  return { valid: true, codes: [] };
}

export function validateQrForAdvance(document: SignDesignDocumentV2, canonicalTarget: string): ClientQrValidation {
  const qrs = document.layers.filter((layer): layer is SignQrLayer => layer.type === 'qr' && layer.visible);
  const codes: string[] = [];
  if (!qrs.length) codes.push('QR_MISSING');
  qrs.forEach(qr => {
    if (qr.qr.target !== canonicalTarget) codes.push('QR_TARGET_INVALID');
    if (!contrastOk(qr.foreground, qr.background)) codes.push('QR_CONTRAST');
  });
  return { valid: codes.length === 0, codes: Array.from(new Set(codes)) };
}

export function addRequiredQr(document: SignDesignDocumentV2, target: string): SignDesignDocumentV2 {
  const size = Math.round(Math.min(document.canvas.widthPx, document.canvas.heightPx) * 0.24);
  return { ...document, layers: [...document.layers, {
    id: 'qr-required', name: 'QR code', type: 'qr', visible: true, locked: false, opacity: 1,
    transform: { x: Math.round((document.canvas.widthPx - size) / 2), y: Math.round((document.canvas.heightPx - size) / 2), width: size, height: size, rotation: 0 },
    qr: { target, errorCorrectionLevel: 'M' }, foreground: '#000000', background: '#ffffff',
  }] };
}

export function fixQr(document: SignDesignDocumentV2, id: string): SignDesignDocumentV2 {
  const size = Math.max(180, Math.round(Math.min(document.canvas.widthPx, document.canvas.heightPx) * 0.24));
  return { ...document, layers: document.layers.map(layer => layer.id === id && layer.type === 'qr' ? {
    ...layer, visible: true, foreground: '#000000', background: '#ffffff',
    transform: { ...layer.transform, width: size, height: size },
  } : layer) };
}
